import { Translate } from '../../services';
import type { errorHandler } from '@wix/essentials';
import { createExportAsyncJob } from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/http';

export const createExportAsyncJobErrors = ({
  translate: t,
}: {
  translate: Translate;
}): errorHandler.ErrorCodesMap<typeof createExportAsyncJob> => {
  return {
    method_endpoint_not_found: () => ({
      message: t(
        'cairo.export.CreateExportAsyncJob.method-endpoint-not-found.error',
      ),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {
          window.open('https://www.wix.com/contact', '_blank');
        },
      },
    }),
  };
};
